// import * as moment from "moment";

// const SESSION_DURATION_SEC = 180;

function getStorageKey(stickerId) {
  return `web-notify_${stickerId}`;
}

export function canSendNotification(stickerId) {
  if (localStorage) {
    const lastNotificationDate = localStorage.getItem(getStorageKey(stickerId));
    if (lastNotificationDate != null) { return false; }
    else { return true; }
    // const dateString = JSON.parse(lastNotificationDate);
    // const now = moment.utc();
    // const diff = now.diff(moment.utc(dateString, 'YYYY-MM-DDTHH:mm:ss'));
    // const d = moment.duration(diff);
    // return d.asSeconds() >= SESSION_DURATION_SEC;
  }

  return true;
}

export function notificationIsSent(stickerId) {
  localStorage && localStorage.setItem(getStorageKey(stickerId), JSON.stringify(new Date()));
}